import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseSortableSearchComponent } from '@components/_base/base-search/base-sortable-search.component';
import { PromoCampaignConfig } from '../_models/promo-campaign-config.model';
import { PromoCampaignConfigService } from '../_services/promo-campaign-config.service';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, concatMap, tap } from 'rxjs/operators';
import { displayError } from '@app/_utils/error-util';

@Component({
  selector: 'app-list-promo-campaign-configs',
  templateUrl: './list-promo-campaign-configs.component.html',
  styleUrls: ['./list-promo-campaign-configs.component.css']
})
export class ListPromoCampaignConfigsComponent extends BaseSortableSearchComponent<PromoCampaignConfig> implements OnInit, OnDestroy {

  searchForm = this.fb.group({
    serviceName:  [null],
    hasTrigger:   [null],
    hasPromoPrice:[null],
    isActive:     [null]
  });

  searchSubscription: Subscription;

  search$ = this.searchSubject.asObservable().pipe(
    tap(() => this.dataLoaded = false),
    concatMap(() =>
      this.promoCampaignConfigService.pageable(this.sortingPaging, this.searchForm.value).pipe(
        tap(([page, totalCount]) => {
          this.sortingPaging.fromRow = page.fromRow;
          this.sortingPaging.toRow = page.toRow;
          this.sortingPaging.totalElements = totalCount;
          this.content = page.content;
          this.dataLoaded = true;
        })
      )
    ),
    catchError(err => {
      displayError(err);
      this.dataLoaded = false;
      this.errorMessageSubject.next(this.translateService.instant('messages.errorLoadingData'));
      return EMPTY;
    })
  );

  constructor(
    private fb:                           FormBuilder,
    private router:                       Router,
    private translateService:             TranslateService,
    private promoCampaignConfigService:   PromoCampaignConfigService
  ) {
    super();
  }

  ngOnInit() {
    this.searchSubscription = this.search$.subscribe();
    this.searchSubject.next();
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
  }

  getTriggerServiceNames(config: PromoCampaignConfig): string {
    if (!config.triggerServices?.length) return '';
    return config.triggerServices.map(s => s.name).join(', ');
  }
}
